<template>
  <login-challenge
    :placeholder="{
      username: $t('scope.text_331'),
    }"
    :form-data-mapper="requestDataMapper"
    :form-rules="formRules"
    :hiddenDomainSelect="true"
    @after-login="handleAfterLogin">
    <template #actions-right>
      <a class="week-link-button" @click="forgetPassword">{{$t('scope.text_345')}}</a>
      <!-- <a class="week-link-button" @click="register">{{$t('scope.text_346')}}</a> -->
    </template>
  </login-challenge>
</template>

<script>
import LoginChallenge from '@/sections/Auth/Login/components/LoginChallenge'
import WindowsMixin from '@/mixins/windows'

export default {
  name: 'LoginChallengeWrap',
  components: {
    LoginChallenge,
  },
  mixins: [WindowsMixin],
  data () {
    return {
      formRules: {
        username: [
          {
            validator: this.checkName,
          },
        ],
      },
    }
  },
  methods: {
    // register () {
    //   this.$router.push('/auth/register')
    // },
    forgetPassword () {
      this.createDialog('ForgetPasswordDialog')
    },
    async handleAfterLogin () {
      try {
        if (this.$route.query) {
          const { source } = this.$route.query
          if (source === 'partner') {
            window.location.href = '/account'
          }
          if (source && source.substring(0, 4) === 'http') {
            window.location.href = source
          }
        }
        // 登录注释
        // const levelData = await this.$store.dispatch('app/fetchLevel')
        // if (levelData.customer_level === 0) {
        //   window.location.href = '/account'
        // }
        return true
      } catch (error) {
        throw error
      }
    },
    requestDataMapper (data) {
      if (this.$route.query.domain) {
        data.domain = this.$route.query.domain
        return data
      }
      return data
    },
    checkName (rule, value, callback) {
      let errorText = ''
      if (value.indexOf('@') >= 0) {
        const arr = value.split('@')
        if (value.indexOf('@') === 0 || arr.length > 2 || !arr[arr.length - 1]) {
          errorText = this.$t('scope.text_347')
          return callback(errorText)
        }
      }
      return callback()
    },
  },
}
</script>
